export default __webpack_public_path__ + "static/media/T_Tesoura.8ed052f1.mp3";